<template>
  <div>
    <Modal v-model="inventoryBalanceDetailsModal" :title="$t('key1004679')" width="1000" :transfer="false"
      :mask-closable="false" @on-visible-change="inventoryBalanceDetailsChange">
      <div class="table_box">
        <Table
          highlight-row
          border
          max-height="550"
          :loading="tableLoading"
          :columns="tbaleColumns"
          :data="tableData"
          @on-sort-change="sortChange">
        </Table>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          :current="pageParams.pageNum"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
      <template #footer>
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center">
            <span class="font-size-14 mr10">{{ $t('key1004680') }}</span>
            <i-switch v-model="pageParams.displayZeroInventoryData" @on-change="pageParamsStatus = true"
              :true-value="1" :false-value="2"></i-switch>
          </div>
          <Button type="primary" @click="inventoryBalanceDetailsModal = false">{{ $t('key1000248') }}</Button>
        </div>
      </template>
    </Modal>
    <!--库存事务明细弹窗-->
    <inventoryTransactionDetailsModal ref="inventoryTransaction" systemType="yms"></inventoryTransactionDetailsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import inventoryTransactionDetailsModal from "@/components/common/inventoryTransactionDetailsModal.vue";
import {getWarehouseManageInfo} from "@/utils/common";

export default {
  name: 'inventoryBalanceDetailsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      inventoryBalanceDetailsModal: false,
      tableLoading: false,
      tbaleColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002315'),
          key: 'warehouseBlockName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620'),
          key: 'warehouseLocalName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242'),
          key: 'allottedNumber',
          minWidth: 130,
          align: 'center',
          sortable: 'custom',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243'),
          key: 'availableNumber',
          minWidth: 130,
          sortable: 'custom',
          sortType: 'desc',
          align: 'center',
          render(h, params) {
            let currentIndex = params.index;
            let isEdit = params.row.$isEdit && v.getPermission('ymsInventory_update');
            let value = params.row.availableNumber;
            let opts = '';
            if (isEdit) {
              let talgValue = params.row.availableNumber;
              opts = h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              },
              [
                h('Input', {
                  style: {
                    width: '80px',
                    height: '32px'
                  },
                  props: {
                    value: value,
                    autofocus: true
                  },
                  attrs: {
                    class: 'availableInput_' + currentIndex,
                  },
                  on: {
                    input: val => {
                      talgValue = val;
                    },
                    'on-enter': () => {
                      v.saveAvailableQuantity(talgValue, 1, params);
                    },
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'md-checkmark',
                    size: 20
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  class: 'cursor',
                  on: {
                    click: () => {
                      v.saveAvailableQuantity(talgValue, 1, params);
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'md-close-circle',
                    color: '#f00',
                    size: 20
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  class: 'cursor',
                  on: {
                    click: () => {
                      v.$set(params.row, '$isEdit', !isEdit);
                    }
                  }
                })
              ]);
            } else {
              opts = h('div', null, [
                h('a', {
                  style: {
                    color: '#2586ED',
                    fontSize: '13px'
                  },
                  on: {
                    click: () => {
                      v.editInput(params.row, currentIndex, isEdit, 1);
                    }
                  }
                }, value),
                h('Icon', {
                  props: {
                    type: 'md-create',
                  },
                  style: {
                    'margin-left': '5px',
                    'cursor': 'pointer'
                  },
                  on: {
                    'click'() {
                      v.editInput(params.row, currentIndex, isEdit, 1);
                    }
                  }
                })
              ]);
            }
            return opts;
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004663'),
          key: 'frozenNumber',
          minWidth: 130,
          sortable: 'custom',
          align: 'center',
          render(h, params) {
            let currentIndex = params.index;
            let invalidQuantityEdit = params.row.$invalidQuantityEdit && v.getPermission('ymsInventory_update');
            let value = params.row.frozenNumber;
            let opts = '';
            if (invalidQuantityEdit) {
              let talgValue = params.row.frozenNumber;
              opts = h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              },
              [
                h('Input', {
                  style: {
                    width: '80px',
                    height: '32px'
                  },
                  props: {
                    value: value,
                    autofocus: true
                  },
                  attrs: {
                    class: 'availableInput_' + currentIndex,
                  },
                  on: {
                    input: val => {
                      talgValue = val;
                    },
                    'on-enter': () => {
                      v.saveAvailableQuantity(talgValue, 2, params);
                    },
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'md-checkmark',
                    size: 20
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  class: 'cursor',
                  on: {
                    click: () => {
                      v.saveAvailableQuantity(talgValue, 2, params);
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'md-close-circle',
                    color: '#f00',
                    size: 20
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  class: 'cursor',
                  on: {
                    click: () => {
                      v.$set(params.row, '$invalidQuantityEdit', !invalidQuantityEdit);
                    }
                  }
                })
              ]);
            } else {
              opts = h('div', null, [
                h('a', {
                  style: {
                    color: '#2586ED',
                    fontSize: '13px'
                  },
                  on: {
                    click: () => {
                      v.editInput(params.row, currentIndex, invalidQuantityEdit, 2);
                    }
                  }
                }, value),
                h('Icon', {
                  props: {
                    type: 'md-create',
                  },
                  style: {
                    'margin-left': '5px',
                    'cursor': 'pointer'
                  },
                  on: {
                    'click'() {
                      v.editInput(params.row, currentIndex, invalidQuantityEdit, 2);
                    }
                  }
                })
              ]);
            }
            return opts;
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 120,
          render: function (h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004665'),
                    show: v.getPermission('ymsInventoryChangeLog_query'),
                    clickFn: () => {
                      v.$refs['inventoryTransaction'].initFun(params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      pageParams: {
        selectType: 2,
        displayZeroInventoryData: 1,
        orderBy: 'availableNumber', // 排序字段 availableNumber 可用数量 allottedNumber 分配数量
        upDown: 'down', // down 降序、up 升序
        vestMerchantId: null,
        ymsWarehouseId: null,
        ymsSkus: [],
        pageNum: 1,
        pageSize: 15,
      },
      total: 0,
    };
  },
  methods: {
    // 初始化数据
    initInventoryBalanceDetailsData(obj) {
      let v = this;
      v.pageParams.vestMerchantId = obj.vestMerchantId;
      v.pageParams.ymsWarehouseId = obj.ymsWarehouseId;
      v.pageParams.ymsSkus = [obj.ymsSku];
      v.getList();
      v.inventoryBalanceDetailsModal = true;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.total = 0;
      v.tableData = [];
      v.tableLoading = true;
      v.axios.post(api.post_ymsInventory_query, v.pageParams).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            v.total = data.total;
            let tableData = data.list || [];
            let ymsWarehouseLocationIds = [];
            if (tableData.length > 0) {
              tableData.map((item) => {
                ymsWarehouseLocationIds.push(item.ymsWarehouseLocationId);
              });
              if (ymsWarehouseLocationIds.length > 0) {
                (async () => {
                  v.tableData = await getWarehouseManageInfo(ymsWarehouseLocationIds, tableData);
                  v.$nextTick(() => {
                    v.tableLoading = false;
                  });
                })();
              }
            } else {
              v.tableData = tableData;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
            if (v.tableData.length > 0) {
              v.tableData.map((item) => {
                item['$isEdit'] = false;
                item['$invalidQuantityEdit'] = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 保存可用数量
    saveAvailableQuantity(talgValue, type, params) {
      let v = this;
      let reg = v.$regular.minPositiveInteger;
      let text = type === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004663');
      if (reg.test(talgValue)) {
        let query = {
          ymsWarehouseLocationId: params.row.ymsWarehouseLocationId,
          ymsProductGoodsId: params.row.ymsProductGoodsId,
          changedNumber: Number(talgValue),
          checkType: type,
          ymsInventoryId: params.row.ymsInventoryId,
          vestMerchantId: params.row.vestMerchantId,
          merchantType: params.row.merchantType
        };
        v.axios.put(api.put_ymsInventory, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          if (res.data.code === 0) {
            if (type === 1) {
              v.$set(params.row, '$isEdit', !params.row.$isEdit);
              v.$set(params.row, 'availableNumber', talgValue);
            } else {
              v.$set(params.row, '$invalidQuantityEdit', !params.row.$invalidQuantityEdit);
              v.$set(params.row, 'frozenNumber', talgValue);
            }
            v.$emit('updateData', true);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          }
        });
      } else {
        v.$Message.error(text + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004664'));
      }
    },
    // 编辑可用数量
    editInput(obj, index, isEdit, type) {
      let v = this;
      setTimeout(() => {
        v.$nextTick(() => {
          document.getElementsByClassName('availableInput_' + index)[0].childNodes[6].focus();
        });
      }, 300);
      if (type === 1) {
        v.$set(obj, '$isEdit', !isEdit);
      } else {
        v.$set(obj, '$invalidQuantityEdit', !isEdit);
      }
    },
    // 数量排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 监听弹窗
    inventoryBalanceDetailsChange(visible) {
      if (!visible) {
        this.tableData = [];
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    inventoryTransactionDetailsModal
  }
};
</script>

<style lang="less">

</style>
